import {PreviewService}  from 'hasta-la-vista-middleware-api/service'
export default {
    name: 'partners_block',
    props:{
        section:Object,
    },

    data(){
        return {
            previewSection:undefined
        }
    },

    created(){
        if(PreviewService.hasPreviewContent('partners')){
            this.previewSection = PreviewService.getPreviewContent().original_item;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/content/partners_block/partners_block.js